import React, { useState, useEffect } from "react";
import warpo from "./warpo.png";
import buet from "./cse_buet.png";
import "./navbar.css";
import { mapOptions } from "./components/MapConfiguration";
import divisionData from "./components/divisionData.json";
import districtData from "./components/districtData.json";
import { FaSearch } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";
import { IoPersonCircle } from "react-icons/io5";
import { Avatar, Menu, MenuItem, IconButton } from "@mui/material";
const Navbar = ({
  setMapCenterFunc,
  setZoom,
  onDivisionSelect,
  onDistrictSelect,
  showRegionInfo,
  setShowRegionInfo,
  mapRef,
  handleClearLeftbar,
  selectedMarker,
  setSelectedMarker,
  setCircleCenter,
  wells: wellsProp,
}) => {
  const [query, setQuery] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [wellsFetched, setWellsFetched] = useState([]);
  const wells = Array.isArray(wellsProp) ? wellsProp : wellsFetched;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const divisions = divisionData.divisions;
  const districts = districtData.districts;
  const onHomeClick = () => {
    window.location.href = "/home"; // Redirect to home page
    console.log("Home clicked");
  };


  const onlinkClick = () => {
    window.location.href = "https://13.233.222.64";
    console.log("Home clicked");
  };
  
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    // Go to profile page logic here
    window.location.href = "/profile"; // Redirect to profile page
    console.log("Profile clicked");
    handleMenuClose();
  };

  const handleLogoutClick = () => {
    handleMenuClose();
    // Perform logout logic here
    console.log("Logout clicked");
    localStorage.removeItem("token"); // Remove token from local storage
    localStorage.removeItem("role"); // Remove role from local storage
    window.location.href = "/"; // Redirect to login page
  };
  const handleSearch = async (searchQuery) => {
    if (!searchQuery) return;

    const response = await fetch(
      `httpss://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        searchQuery
      )}&key=${mapOptions.googleMapApiKey}`
    );
    const data = await response.json();

    if (data.results && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;

      console.log("Search result:", { lat, lng }); // Add a console log here to check if it's returning the correct data.

      if (isFinite(lat) && isFinite(lng)) {
        setMapCenterFunc(lat, lng);
        setZoom(10); // You can set the zoom level to a reasonable value (you can adjust this as needed).
      } else {
        console.error("Invalid coordinates:", { lat, lng });
      }
    } else {
      console.error("No results found for:", searchQuery);
    }
  };

  const handleDivisionChange = (e) => {
    const divId = e.target.value;
    setSelectedDivision(divId);
    setSelectedDistrict("");
    onDivisionSelect(divId);
  };

  const handleDistrictChange = (e) => {
    const distId = e.target.value;
    setSelectedDistrict(distId);
    onDistrictSelect(distId);
    if (distId) {
      const district = districts.find((d) => d.id === distId);
      const lat = parseFloat(district.lat);
      const lng = parseFloat(district.long);
      if (isFinite(lat) && isFinite(lng)) {
        setMapCenterFunc(lat, lng);
        setZoom(10);
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(wellsProp)) return;
    fetch("https://warpo-dashboard.cse.buet.ac.bd/api/wells")
      .then((res) => res.json())
      .then((data) => {
        setWellsFetched(data);
        console.log(data);
      })
      .catch((err) => console.error(err));
  }, [wellsProp]);

  useEffect(() => {
    if (selectedMarker) {
      // const well = wells.find(
      //   (w) => w.id.toString() === selectedWell.toString()
      // );
      // You can use well.lat, well.lng, etc. to plot on the map
      console.log("Selected Well:", selectedMarker.wellId);
    }
  }, [selectedMarker]);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src={warpo} alt="warpo" />
        <img src={buet} alt="buet" style={{ width: "60px", height: "60px" }} />
        {/* <button
          onClick={() => {
            if (showRegionInfo) {
              handleClearLeftbar();
              setShowRegionInfo(false);
            } else {
              setShowRegionInfo(true);
            }
          }}
          className="region-btn"
          // style={{ marginLeft: '1rem' }}
        >
          {showRegionInfo ? "Hide Regions" : "Show Regions"}
        </button> */}
      </div>
      <div className="navbar-search" style={{ marginLeft: "1rem" }}>
        <select
          className="navbar-select"
          value={selectedDivision}
          onChange={handleDivisionChange}
        >
          <option value="">Division</option>
          {divisions.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>

        {selectedDivision && (
          <select
            className="navbar-select"
            value={selectedDistrict}
            onChange={handleDistrictChange}
          >
            <option value="">District</option>
            {districts
              .filter(
                (d) => d.division_id?.toString() === selectedDivision.toString()
              )
              .map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
          </select>
        )}

        <select
          className="navbar-select-well"
          value={
            selectedMarker?.wellId != null && selectedMarker.wellId !== ""
              ? String(selectedMarker.wellId)
              : ""
          }
          onChange={(e) => {
            const val = e.target.value;
            if (window.selectedWellMarker) {
              window.selectedWellMarker.setMap(null);
              window.selectedWellMarker = null;
            }
            if (!val) {
              setSelectedMarker(null);
              if (typeof setCircleCenter === "function") {
                setCircleCenter(null);
              }
              return;
            }
            const wellObj = wells.find((w) => String(w.wellId) === val);
            if (!wellObj) return;

            setSelectedMarker(wellObj);

            const lat = wellObj.locations?.lat;
            const lng = wellObj.locations?.lng;
            if (lat == null || lng == null) return;

            const position = { lat, lng };
            if (typeof setCircleCenter === "function") {
              setCircleCenter(position);
            }
            const map = mapRef.current;
            if (map && typeof map.panTo === "function") {
              map.panTo(position);
              map.setZoom(10);
            }
          }}
        >
          <option value="">Select Well</option>
          {wells.map((well) => (
            <option key={String(well.wellId)} value={String(well.wellId)}>
              {well.wellId}
            </option>
          ))}
        </select>

        {/* <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search location..."
          className="navbar-input"
          style={{ marginRight: "0.75rem" }}
        />

        <button onClick={() => handleSearch(query)} className="navbar-icon-btn">
          <FaSearch size={18} />
        </button> */}
      </div>

      <button
        onClick={onHomeClick}
        className="right-icon-btn"
        style={{ marginRight: "0.75rem" }}
      >
        <FaHome size={20} />
        Home
      </button>

      <button
        onClick={onlinkClick}
        className="right-icon-btn2"
        style={{ marginRight: "0.75rem" }}
      >
       Data Collection Dashboard
    
      </button>

      {/*             
      <>
            <button  onClick={onHomeClick} className="right-icon-btn" style={{ marginRight: "0.75rem" }}>
              <FaHome  /> Home
            </button>
             
      
              <IconButton onClick={handleAvatarClick} sx={{ p: 0}} className="right-icon-btn" style={{ marginRight: "0.75rem" }}>
                  <Avatar alt="Your Name" src="/path-to-image.jpg" />
              </IconButton>
      
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                onClick={handleMenuClose}
                PaperProps={{
                  elevation: 3,
                  sx: {
                    mt: 1.5,
                    borderRadius: "12px",
                    filter: "drop-shadow(0px 4px 10px rgba(0,0,0,0.1))",
                  }
                }}
              >
                <MenuItem onClick={handleProfileClick}><IoPersonCircle/>Profile</MenuItem>
                <MenuItem onClick={handleLogoutClick}> <FaSignOutAlt/> Logout</MenuItem>
              </Menu>
            </> */}
    </nav>
  );
};

export default Navbar;
